// The form is shared between the customer app and the professional app, which
// build their API base and auth header differently. Each app injects its own
// once, at import time, rather than the form importing either app's helpers.

let deps = {
  getAPIUrl: (path) => path,
  getAuthToken: () => '',
  // The host's own mark: EG and WG ship different files, and the professional
  // app ships its own. The loader is the only thing that uses it.
  logoSrc: '',
  // Whether this is the build egadmin opens. Login as User signs in with the
  // client's own token, so nothing in the request says ops is the one
  // reading; only the build does.
  isAdmin: () => false,
};

export const configureCreativePreferences = (next) => {
  deps = { ...deps, ...next };
};

export const apiUrl = (path) => deps.getAPIUrl(path);
export const authHeader = () => deps.getAuthToken();
export const logoUrl = () => deps.logoSrc;
export const isAdminBuild = () => !!deps.isAdmin && deps.isAdmin();
